import { render, staticRenderFns } from "./ImgSlider.vue?vue&type=template&id=e42a8d76"
import script from "./ImgSlider.vue?vue&type=script&lang=js"
export * from "./ImgSlider.vue?vue&type=script&lang=js"
import style0 from "./ImgSlider.vue?vue&type=style&index=0&id=e42a8d76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports